import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import {
    CharmSelectionType,
    QuickComposeViewType,
} from 'owa-calendar-helpers-types/lib/ComposeTypes';
import type { QuickComposeViewState } from 'owa-calendar-compose-types';
import { getDefaultShouldShortenEventDuration } from 'owa-calendar-cloud-settings';
import { createCharmSuggestionsViewState } from 'owa-calendar-charm-suggestions-data';

export default function createQuickComposeViewState(
    event: CalendarEvent,
    anchor: HTMLDivElement | string,
    viewType: QuickComposeViewType
): QuickComposeViewState {
    return {
        surfaceAnchor: anchor,
        charmSelection: getCharmSelectionType(event),
        isUndoNotificationShown: false,
        isOptionalAttendeeWellEnabled: false,
        shouldFocusOptionalAttendeeWellOnMount: false,
        showCompactRecipientWell: false,
        unresolvedLocation: null,
        showExpandedEditor: false,
        bodyViewState: {
            content: '',
            isDirty: false,
        },
        viewType: viewType,
        isOnlineMeetingExplicitlySet: false,
        shouldAdjustStartTimeEndTime: getDefaultShouldShortenEventDuration(),
        charmSuggestionsViewState: createCharmSuggestionsViewState(),
    } as QuickComposeViewState;
}

function getCharmSelectionType(event: CalendarEvent): CharmSelectionType {
    // If this is an existing item with a charm set, set the selection type
    // to Manual, otherwise set it to None
    return event.ItemId?.Id && !(event.CharmId == null || event.CharmId == 0)
        ? CharmSelectionType.Manual
        : CharmSelectionType.None;
}
